import { z } from 'zod';

const numberSchema = (valueIfNaN, schema = z.number()) => z.preprocess(
  (val) => typeof val === "number" && Number.isNaN(val) ? valueIfNaN : val,
  schema
);

export { numberSchema };
//# sourceMappingURL=schemas.js.map
